export default function SolutionsHero() {
  return (
    <section className="bg-white pt-32 pb-20 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-6xl md:text-7xl font-light tracking-tight text-gray-900 mb-6">
          AI Systems for Operational Control
        </h1>
        <p className="text-xl md:text-2xl font-light text-gray-600 leading-relaxed max-w-3xl mx-auto">
          Sapentis AI designs intelligent automation systems that remove bottlenecks, improve response time, and create predictable growth infrastructure.
        </p>
      </div>
    </section>
  );
}